function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  colorInterpolationFilters: "auto",
  id: "atoms-icon-edit_inline_svg__a"
}, React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 0 0.627451 0 0 0 1.000000 0"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)",
  filter: "url(#atoms-icon-edit_inline_svg__a)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M5.819 12.998l2.081-.231 6.51-6.51a.875.875 0 000-1.238l-1.095-1.096a.875.875 0 00-1.238 0l-6.51 6.51-.232 2.082a.437.437 0 00.484.483zm7.112-6.206l-1.39-1.39 1.009-1.008a.207.207 0 01.294 0L13.94 5.49a.207.207 0 010 .293l-1.01 1.009zM11 14.333a1 1 0 001-1V9.91a.124.124 0 00-.213-.087l-.416.417a.117.117 0 00-.038.087v3.006c0 .184-.15.334-.333.334H3.667a.334.334 0 01-.334-.334V6c0-.183.15-.333.334-.333H9.34a.129.129 0 00.087-.038l.417-.417C9.923 5.135 9.867 5 9.756 5h-6.09a1 1 0 00-1 1v7.333a1 1 0 001 1H11zm-4.969-2.029l.173-1.564 4.867-4.865 1.39 1.39-4.865 4.866-1.565.173z",
  fill: "#212121",
  fillRule: "nonzero"
}));

function SvgAtomsIconEditinline(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2);
}

export default SvgAtomsIconEditinline;